document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth > 749) return;

  const filters = document.querySelector('#main-collection-filters');

  if (!filters) return;

  const marker = document.createElement('div');
  filters.parentNode.insertBefore(marker, filters);

  function getHeaderHeight() {
    const stack = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--rt-header-stack')
    );
    if (!isNaN(stack) && stack > 0) return stack;
    const header = document.querySelector('.header-wrapper');
    return header ? header.offsetHeight : 72;
  }

  function updateStickyFilter() {
    const headerHeight = getHeaderHeight();

    filters.style.setProperty('--reevatara-header-height', headerHeight + 'px');

    const markerTop = marker.getBoundingClientRect().top;

    if (markerTop <= headerHeight) {
      marker.style.height = filters.offsetHeight + 'px';
      filters.classList.add('reevatara-filter-fixed');
    } else {
      marker.style.height = '0px';
      filters.classList.remove('reevatara-filter-fixed');
    }
  }

  window.addEventListener('scroll', updateStickyFilter, { passive: true });
  window.addEventListener('resize', updateStickyFilter);

  updateStickyFilter();
});
